'use client';

import { useContext } from 'react';
import { TabsContext } from './TabsContext';
import { cn, TabListProps, TabsVariant } from 'types';

export function TabList(props: TabListProps) {
  const { children, className = '' } = props;
  const { variant } = useContext(TabsContext);

  return (
    <div className={cn(className)}>
      <ul
        className={cn('flex', {
          'gap-8': variant === TabsVariant.NORMAL,
          "relative after:absolute after:h-1 after:w-[calc(100%+6rem)] after:-ml-12 after:content-[''] after:-bottom-1 after:z-1 after:left-0 after:right-0 after:bg-neutralGrey":
            variant === TabsVariant.UNDERLINE,
          'gap-1 p-1 bg-neutralGrey rounded-sm w-fit': variant === TabsVariant.FILLED,
        })}
      >
        <>{children}</>
      </ul>
    </div>
  );
}

TabList.displayName = 'Tabs.TabList';
